import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCircleCheck } from '@fortawesome/free-solid-svg-icons/faCircleCheck'
import { faCopy } from '@fortawesome/free-solid-svg-icons'
import { Button } from 'react-bootstrap'
import { useState } from 'react'
import { throwSuccessMessage } from '../../utils/Errors'
import styles from './styles/index.module.scss'

interface Props {
    data: string
}

export const CopyStateIdBtn = ({ data }: Props) => {
    const [flag, setFlag] = useState<boolean>(false)

    const handleCopy = () => {
        if (!data) return
        navigator.clipboard
            .writeText(data)
            .then(() => throwSuccessMessage('Copied to clipboard'))
            .catch((error) =>
                console.error('Failed to copy secret key:', error)
            )

        setFlag(true)
        setTimeout(() => {
            setFlag(false)
        }, 5500)
    }

    return flag ? (
        <span className="p-1">
            <FontAwesomeIcon icon={faCircleCheck} />
        </span>
    ) : (
        <Button
            className={`btn-clean p-1 ${styles.copyBtn}`}
            style={{
                width: 'fit-content !important',
                minWidth: 'unset',
            }}
            onClick={handleCopy}
        >
            <FontAwesomeIcon
                icon={faCopy}
                style={{ color: '#40A2B5' }}
            />
        </Button>
    )
}
